import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';

const AllReports = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/AllReports.js')
);

const PrescriptionsReport = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/Prescriptions.js')
);

const MedicalRxReport = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/MedicalRx.js')
);

const InvoicesReport = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/Invoices.js')
);

const LabOrdersReport = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/LabOrders.js')
);

const ReferralsReport = asyncComponent(() =>
  import('../../containers/authorised/reports/listing/Referrals.js')
);

const ReportsRoutes = (
  <Switch>
    <Route exact path="/report" component={AllReports} />
    <Route exact path="/report/prescriptions" component={PrescriptionsReport} />
    <Route exact path="/report/medical-rx" component={MedicalRxReport} />
    <Route exact path="/report/invoices" component={InvoicesReport} />
    <Route exact path="/report/lab-orders" component={LabOrdersReport} />
    <Route exact path="/report/referrals" component={ReferralsReport} />
  </Switch>
);

export default ReportsRoutes;